var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpLevel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.25 17.5347H12.2228C10.1518 17.5347 8.47296 15.8559 8.47296 13.7849V8.53509L6.28304 10.755C6.14222 10.897 5.95053 10.9768 5.75056 10.9768C5.55059 10.9768 5.35891 10.897 5.21809 10.755C4.9273 10.4625 4.9273 9.99006 5.21809 9.69754L8.69045 6.22518C8.7611 6.15421 8.84525 6.09811 8.93794 6.06018C9.11946 5.97995 9.32639 5.97995 9.50792 6.06018C9.59906 6.10095 9.68272 6.15672 9.75541 6.22518L13.2503 9.69754C13.5051 9.9951 13.488 10.4387 13.2109 10.7157C12.9339 10.9927 12.4904 11.0098 12.1928 10.755L9.9729 8.56508V13.8149C9.9729 15.0575 10.9802 16.0648 12.2228 16.0648H19.25C19.6642 16.0648 20 16.4006 20 16.8148C20 17.229 19.6642 17.5647 19.25 17.5647V17.5347Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpLevel);
export default ForwardRef;